module.exports = __webpack_public_path__ + "img/user-plan.d4e1eaa6.svg";